import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from '@app/components/pipes/pipes.module';
import { AngularMaterialModule } from '../angular-material/angular-material.module';

import { VideoPlayerDialogComponent } from './video-player-dialog/video-player-dialog.component';
import { TimeoutDialogComponent } from './timeout-dialog/timeout-dialog.component';
import { ConfirmActionDialogComponent } from './confirm-action-dialog/confirm-action-dialog.component';
import { ImagesViewerDialogComponent } from './images-viewer-dialog/images-viewer-dialog.component';
import { AddMaterialDialogComponent } from './add-material-dialog/add-material-dialog.component';

@NgModule({
    declarations: [
        VideoPlayerDialogComponent,
        TimeoutDialogComponent,
        ConfirmActionDialogComponent,
        ImagesViewerDialogComponent,
        AddMaterialDialogComponent
    ],
    exports: [
        VideoPlayerDialogComponent,
        TimeoutDialogComponent,
        ConfirmActionDialogComponent,
        ImagesViewerDialogComponent,
        AddMaterialDialogComponent
    ],
    imports: [
        CommonModule,
        AngularMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        PipesModule
    ]
})
export class DialogsModule { }
